import { render, staticRenderFns } from "./CfdisImport.vue?vue&type=template&id=01c702dc"
import script from "./CfdisImport.vue?vue&type=script&lang=js"
export * from "./CfdisImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports